var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#00B4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2587 17.8469L25.2087 17.3219L22.8462 11.7594C22.4212 10.7469 20.9712 10.7469 20.5462 11.7594L18.1837 17.3344L12.1462 17.8469C11.0462 17.9344 10.5962 19.3094 11.4337 20.0344L16.0212 24.0094L14.6462 29.9094C14.3962 30.9844 15.5587 31.8344 16.5087 31.2594L21.6962 28.1344L26.8837 31.2719C27.8337 31.8469 28.9962 30.9969 28.7462 29.9219L27.3712 24.0094L31.9587 20.0344C32.7962 19.3094 32.3587 17.9344 31.2587 17.8469ZM21.6962 25.7969L16.9962 28.6344L18.2462 23.2844L14.0962 19.6844L19.5712 19.2094L21.6962 14.1719L23.8337 19.2219L29.3087 19.6969L25.1587 23.2969L26.4087 28.6469L21.6962 25.7969Z",
    fill: "#004762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsCard);
export default __webpack_public_path__ + "static/media/Analytics_Card.33a0ae2515012eb2d71cdea964865a26.svg";
export { ForwardRef as ReactComponent };